const routerNamePrefix = 'trainConfirm'
const documentTitle = '岗前培训确认'

const router = [
  {
    path: 'main',
    name: `${routerNamePrefix}_main`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_main` */ './main'),
    meta: {
      title: documentTitle,
    },
  },
  {
    path: 'success',
    name: `${routerNamePrefix}_success`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_success` */ './success'),
    meta: {
      title: documentTitle,
    },
  },
  {
    path: 'notAttend',
    name: `${routerNamePrefix}_notAttend`,
    component: () =>
      import(/* webpackChunkName: `${routerNamePrefix}_notAttend` */ './notAttend'),
    meta: {
      title: documentTitle,
    },
  },
]

export default router
export { routerNamePrefix }
